import { create } from 'zustand';

interface ViewRefreshStore {
  refreshCounter: number;
  refreshInterval: number | null; // null = manual only, or interval in ms
  intervalTimerId: NodeJS.Timeout | null;
  setRefreshInterval: (interval: number | null) => void;
  triggerRefresh: () => void;
  isRefreshing: boolean;
  cleanup: () => void; // Cleanup function to clear intervals
}

export const useViewRefreshStore = create<ViewRefreshStore>((set, get) => ({
  refreshCounter: 0,
  refreshInterval: null,
  intervalTimerId: null,
  isRefreshing: false,

  setRefreshInterval: (interval: number | null) => {
    const { intervalTimerId } = get();
    
    // Clear existing interval if any
    if (intervalTimerId) {
      clearInterval(intervalTimerId);
    }

    // Set new interval if provided
    let newTimerId: NodeJS.Timeout | null = null;
    if (interval !== null && interval > 0) {
      newTimerId = setInterval(() => {
        get().triggerRefresh();
      }, interval);
    }

    set({
      refreshInterval: interval,
      intervalTimerId: newTimerId,
    });
  },

  triggerRefresh: () => {
    set((state) => ({
      refreshCounter: state.refreshCounter + 1,
      isRefreshing: true,
    }));

    // Reset isRefreshing after a short delay to allow cards to react
    setTimeout(() => {
      set({ isRefreshing: false });
    }, 100);
  },

  cleanup: () => {
    const { intervalTimerId } = get();
    if (intervalTimerId) {
      clearInterval(intervalTimerId);
    }
    set({
      refreshInterval: null,
      intervalTimerId: null,
    });
  },
}));

